import { render } from "./ItemBranchSelector.vue?vue&type=template&id=6f5b2bd3"
import script from "./ItemBranchSelector.vue?vue&type=script&lang=js"
export * from "./ItemBranchSelector.vue?vue&type=script&lang=js"

import "./ItemBranchSelector.vue?vue&type=style&index=0&id=6f5b2bd3&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__